import { Globe2 } from "lucide-react";
import type { Site } from "../lib/api";
import { siteHost } from "../lib/domains";
import { siteDisplayState } from "../lib/siteLifecycle";
import { SavedPreviewImage } from "./SavedPreviewImage";

// Cards use a static screenshot. Missing screenshots must not boot an entire
// website (scripts, media and integrations) inside every dashboard card.
export default function SiteThumbnail({
  site,
  className,
}: {
  site: Site;
  className: string;
}) {
  // The preview build is what a card should reflect — published or not — falling
  // back to the live build.
  const buildId = site.previewBuildId ?? site.liveBuildId;
  const state = siteDisplayState(site);
  return <BuildThumbnail buildId={buildId} fallbackBuildId={site.liveBuildId} label={siteHost(site.subdomain)} state={state} className={className} />;
}

/** The same real screenshot/fallback for customer sites and standalone admin builds. */
export function BuildThumbnail({ buildId, fallbackBuildId, label, state, className }: {
  buildId: string | null; fallbackBuildId?: string | null; label: string; state: string; className: string;
}) {
  return (
    <div className={`${className}${buildId ? " has-thumbnail" : ""}`}>
      <Globe2 size={25} />
      <span>{label.slice(0, 1).toUpperCase()}</span>
      <SavedPreviewImage buildId={buildId} fallbackBuildId={fallbackBuildId} label={`Preview of ${label}`} />
      <span className={`thumbnail-status ${state}`}>
        {state === "active" ? "Live" : state === "draft" ? "Draft" : state.replace("-", " ")}
      </span>
    </div>
  );
}
